import React from 'react';
import ReactDOM from 'react-dom';

import App from './app/components/App/App';

ReactDOM.render(<App />, document.getElementById('approot'));
